export default "__VITE_ASSET__Ctx_KOaT__"